/**
 * Notes mid-type made safe to render: an unclosed bold marker stays hidden and
 * an unclosed link shows only its label, so no markdown syntax flashes.
 */
export function withoutOpenMarkup(text: string): string {
  return withoutOpenBold(withoutOpenLink(text));
}

function withoutOpenLink(text: string): string {
  return text
    .replace(/\[([^\]]*)\]\((?:[^()\s]|\([^()\s]*\)?)*(?:\s+(?:"[^"]*"?)?)?$/, "$1")
    .replace(/\[([^\]]*)$/, "$1");
}

function withoutOpenBold(text: string): string {
  const trailing = /\*+$/.exec(text)?.[0] ?? "";
  const base = text.slice(0, text.length - trailing.length);
  const unbalanced = (base.split("**").length - 1) % 2 === 1;
  if (!unbalanced) return base;
  if (trailing.length >= 2) return text;
  const runs = [...base.matchAll(/\*{2,}/g)];
  const last = runs.at(-1);
  if (!last || last.index === undefined) return base;
  return base.slice(0, last.index) + base.slice(last.index + last[0].length);
}

/**
 * A bold label that opens a line starts its own block, with its text on the
 * next line, so every part reads the same way and none is absorbed by the
 * list above it.
 */
export function labelsOnOwnLine(text: string): string {
  return text
    .replace(/([^\n])\n(?=\*\*[^*\n]+:\*\*)/g, "$1\n\n")
    .replace(/^(\*\*[^*\n]+:\*\*)[ \t]+(?=\S)/gm, "$1\n");
}
